/**
 * Theme Hook
 * Manages dark/light mode based on user preference or system setting
 */

import { useEffect } from 'react'
import { useSettingsStore } from '@stores/settingsStore'

export function useTheme() {
  const theme = useSettingsStore((state) => state.settings.theme)

  useEffect(() => {
    const root = document.documentElement

    // Apply the theme attribute
    root.setAttribute('data-theme', theme)

    // For system theme, we let CSS handle it via media query
    // The data-theme="system" attribute allows CSS to use prefers-color-scheme
  }, [theme])

  return theme
}
